angular.module('impactx.login').controller('LoginSelectExternalCtrl', [
    'dataGen',
    '$window',
    '$redirect',
    '$routeParams',
    LoginSelectExternalCtrl]);

function LoginSelectExternalCtrl(dataGen, $window, $redirect, $routeParams) {
    var self = this;

    dataGen.getData({}, {osuTan: $routeParams.osuTan, idpId: $routeParams.idPId}, "/login/selectexternalauthorization").then(function (data) {
        if (data.data && data.data.url) {
            $window.location.href = data.data.url;
        }
        else {
            $redirect.redirectTo(null, "/chooseexternallogin")
        }
    });
}